// extracted by mini-css-extract-plugin
export default {"creditValidity":"creditValidity__lUrPLa","label":"label__AWFTbF","credit":"credit__h49x5g","remainingCredit":"remainingCredit__UAAfAh","space":"space__RcaEIn"};